import React from 'react'
import { convertText } from '../../../shared/utils/convertFirstCharacterToUppercase'
import './return-button.scss'

const ReturnButton = ({ title = 'VOLVER', href, ...params }) => {
  return (
    <a href={href} className='a-return-button' {...params}>
      <i className='icon-chevron-left'></i> {convertText(title)}
    </a>
  )
}

export default ReturnButton
